import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.inner}`}>
        <div className={styles.links}>
          <Link to="/about">About</Link>
          <Link to="/suggest">Suggest a Venue</Link>
          <Link to="/privacy">Privacy Policy</Link>
        </div>
        <div className={styles.copy}>
          <span>© {new Date().getFullYear()} ConcertFinder</span>
          <span className={styles.adDisclosure}>This site contains advertising</span>
        </div>
      </div>
    </footer>
  );
}
